// Collects the i18n namespaces declared in `handle.i18n` by the matched routes (client mirror of getRouteNamespaces)

interface RouteMatchWithHandle {
  handle?: unknown;
}

export function getMatchedRouteNamespaces(matches: RouteMatchWithHandle[]): string[] {
  const namespaces = matches.flatMap(({ handle }) => {
    if (!handle || typeof handle !== 'object' || !('i18n' in handle)) return [];
    const { i18n } = handle;
    if (typeof i18n === 'string') return [i18n];
    if (Array.isArray(i18n)) return i18n.filter((ns): ns is string => typeof ns === 'string');
    return [];
  });
  return [...new Set(namespaces)];
}
